module.exports = __webpack_public_path__ + "static/media/beach.bbf9a657.jpg";